import { combineEpics, ofType } from "redux-observable";
import { catchError, concatMap, from, map, mergeMap, of, withLatestFrom } from "rxjs";
import { RootState } from "../../../store/ConfigureStore";
import { getGasDataOnDesignChange } from "../../../services/jetlift/jetlift-output/gasCalculation.service";
import { GasCalculationData } from "../../../store/model/calculations/calculation";
import { setGasCalculationComplete, setGasIntakeData, setShowOutput } from "../../../store/jetlift/jetlift-output/GasCalculationSlice";
import { loadDepletionPressure, loadFutureProductionRate } from "../../../store/jetlift/jetlift-output/BasicCalculationSlice";

const gasIntakeData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
           "jetlift/gasCalculations/gasCalculationStart"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.jetlift?.gasCalculations?.gasIntakeData)),
            state$.pipe(map((state: RootState) => state?.jetlift?.tubing?.tubingInput)),
            state$.pipe(map((state: RootState) => state?.jetlift?.fluid?.fluidInput)),
            state$.pipe(map((state: RootState) => state?.jetlift?.well?.wellInput)),
            state$.pipe(map((state: RootState) => state?.jetlift?.gasCalculations?.gasIntakeData?.naturalSepEff)),
            state$.pipe(map((state: RootState) => state?.jetlift?.fluid?.region)),
            state$.pipe(map((state: RootState) => state?.jetlift?.fluid?.regionList)),
            state$.pipe(map((state: RootState) => state?.jetlift?.tubing?.units)),
            state$.pipe(map((state: RootState) => state?.createProject?.jetliftProjectID?.projectID)),
        ),
        concatMap(([actionData, gasData, tubingInput, fluidInput, wellInput, intakeNaturalSepEff, region, regionList, unit, projectId]) => {
            const selRegion = regionList?.find((x: any) => x?.value === region);
            let intake_NaturalSepEff = 0;
            let GOR = +fluidInput?.gor || 0;
            let gasCompression = +fluidInput?.gasCompressibility || 0;
            const gasAvailability = fluidInput?.gasAvailblty;
            if (gasAvailability === '0') {
                GOR = 0;
                gasCompression = 0;
            }
            const postObj = {
                casingID: +tubingInput?.casingID || 0,
                casingIDUnit: +unit?.unitCasingIDListVal,
                tubingOD: +tubingInput?.tubing1_tubingOD || 0,
                productionRate: +wellInput?.productionRate || 0,
                productionRateUnit: +unit?.unitProductionRateListVal,
                spGrWater: +fluidInput?.spGrWater || 0,
                waterCut: +fluidInput?.waterCut || 0,
                combinedSpGr: +fluidInput?.combinedSpGr || 0,
                liquidPhaseSpGr: +fluidInput?.liquidPhaseCombinedSpGr || 0,
                bwpd: +fluidInput?.bwpd || 0,
                bwpdUnit: +unit?.unitBWPDListVal,
                oilAPI: +fluidInput?.oilAPI || 0,
                spGrOil: +fluidInput?.spGrOil || 0,
                bopd: +fluidInput?.bopd || 0,
                bopdUnit: +unit?.unitBOPDListVal,
                spGrGas: +fluidInput?.spGrGas || 0,
                gor: GOR,
                gorUnit: +unit?.unitGORListVal,
                bottomHoleTemp: +fluidInput?.bottomHoleTemp || 0,
                bottomHoleTempUnit: +unit?.unitBottomHoleTempListVal,
                gasDesign: 0,
                unitSystem: +tubingInput?.unitSys,
                bubblePointPressure: +fluidInput?.bubblePoint || 0,
                bubblePointPressureUnit: +unit?.unitBubblePointListVal,
                isNatural: false,
                flop: +wellInput?.flop || 0,
                flopUnit: +unit?.unitFLOPListVal,
                perforation: +wellInput?.perforation || 0,
                perforationUnit: +unit?.unitPerforationListVal,
                pumpSetting: +wellInput?.pumpSetting || 0,
                pumpSettingUnit: +unit?.unitPumpSettingListVal,
                casingPressure: +wellInput?.casingPressure || 0,
                casingPressureUnit: +unit?.unitCasingPressureListVal,
                isGas: fluidInput?.gasAvailblty === "1",
                gasCompressibility: gasCompression,
                gasProduction: +fluidInput?.gasProduction || 0,
                gasProductionUnit: +unit?.unitGasProductionListVal,
                inflowType: +wellInput?.inflowTypeLstVal,
                projectId: projectId,
                intakeNaturalSeparatorEff: intake_NaturalSepEff,
                chargePumpShowAll: false,
                regionName: selRegion?.label ?? ""
            }

            return from(getGasDataOnDesignChange(postObj)).pipe(
                map(result => {
                    var intakeGasOutput = {
                        naturalSepEff: result?.naturalSepEff,
                        rs: result?.rs,
                        bo: result?.bo,
                        bg: result?.bg,
                        gasVolume: result?.gasVolume,
                        oilVolume: result?.oilVolume,
                        waterVolume: result?.waterVolume,
                        tfv: result?.tfv,
                        freeGas: result?.freeGas,
                        gor: result?.gor,
                        glr: result?.glr,
                        liquidPhaseDensity: result?.liquidPhaseDensity,
                        gasCompressibility: result?.gasCompressibility,
                        pip: result?.pip,
                        compositeSpGr: result?.compositeSpGr,
                        flop: result?.flop,
                        temperatureOut: result?.temperatureOut,
                        liquidPhaseSpGr: result?.liquidPhaseSpGr,
                    } as GasCalculationData;
                    var output = {
                        intakeGasOutput,
                    }
                    return output;
                }),
                mergeMap(output => {
                    return [
                        setGasIntakeData(output?.intakeGasOutput),
                        setGasCalculationComplete(true),
                        loadFutureProductionRate(),
                        loadDepletionPressure(),
                        setShowOutput(true),
                    ]
                }),
                catchError((error) => of(console.log(error))),
            )
        })
    )
};

export const jetliftGasCalculationEpic = combineEpics(gasIntakeData);